import React, { useContext } from 'react';
import { AppContext } from 'App.context.js';
import DefaultLayout from 'Components/DefaultLayout/DefaultLayout.jsx';
import ContentBox from 'Components/common/ContentBox/ContentBox.jsx';
import AppSelector from 'Components/common/AppSelector/AppSelector';
import AppButton from 'Components/common/Forms/AppButton/AppButton.jsx';

import useRHConfigHook from './RHConfig.hook.js';
import PoliceAPI from '../Platforms/PoliceAPI/PoliceAPI.jsx';
import PoliceSFTP from '../Platforms/PoliceSFTP/PoliceSFTP.jsx';
import PoliceS3 from '../Platforms/PoliceS3/PoliceS3.jsx';
import Colors from 'constants/Colors.js';
import RequestSuscription from 'Components/common/RequestSuscription/RequestSuscription.jsx';

export default function RHConfig() {
  const { state, actions } = useRHConfigHook();
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const renderPlatform = () => {
    switch (state.selectedOptionConnection) {
      case 'SFTP':
        return <PoliceSFTP type="RH" />;
      // case 'API': //TODO no available integrations for this for now
      //   return <PoliceAPI type="RH" />;
      case 'S3':
        return <PoliceS3 type="RH" />;
      default:
        return null;
    }
  };

  return (
    <DefaultLayout title={translate('layout.policeReportConfig')} enableAllHotels={false}>
      {state.suscription ? (
        <ContentBox title={translate('policeReport.connectionType')}>
          <AppSelector
            title={translate('policeReport.chooseConnectionType')}
            value={state.selectedOptionConnection}
            options={state.connectionOptions}
            onOptionSelected={actions.handleSelectConnection}
          />
          {renderPlatform()}
        </ContentBox>
      ) : (
        <RequestSuscription suscription="bookings_report" />
      )}
    </DefaultLayout>
  );
}
